<template>
   <div class="container">

<img class="loginTitle" src="../../assets/login_title.png" alt=""/>

<van-form style="margin-top: 50px;">
    <van-field
      class="inputBg"
      v-model="phone"
      name="手机号"
      placeholder="请输入手机号"
    />  
    <van-field
      style="margin-top: 20px;"
      v-model="code"
      name="短信验证码"
      placeholder="请输入短信验证码"
    >
      <template #button>
        <div class="codeBtn" @click="sendSMS" :disabled="isCoding">
          {{ btnText }}
        </div>
       
      </template>
    </van-field>
  </van-form>

  <div
      @click="login"
      class="btn"
      style="margin-top: 16px"
    >注册</div>
    <img src="../../assets/downnew/down_new_desc.png" alt="" style="width: 90%; object-fit: contain;" />
</div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      phone: undefined,
      code: undefined,
      password: undefined,
      password2: undefined,
      inviteCode: "",
      appid: "",
      shareById:"",
      isCoding: false,
      codingTime: 60,
      btnText:"发送验证码",
      isCheck: true,
      ios: true,
    };
  },
  mounted() {
    this.inviteCode = this.$route.query.inviteCode;
    this.appid = this.$route.query.appid;
    this.shareById = this.$route.query.shareById;
    this.$store.commit("setAppId", this.appid);
    localStorage.setItem("appId", this.appid);
    this.appSource();
    // console.log(this.inviteCode, this.shareById);
  },
  methods: {
    login() {
      if (!this.checkLink()) {
        return;
      }
      if (this.phone && this.code) {
        this.$request.POST({
          url: "/lobster/h5/login",
          data: {
            invitation: this.inviteCode,
            // password:this.password,
            shareById:this.shareById,
            phone: this.phone,
            phoneCode: this.code,
            appId: this.appid,
          },
          success: (res) => {
            this.$router.push({
              name: "playletDownload",
              query: { isRegister: true,token:res.token },
            });
          },
          fail: (msg) => {
            if(msg=="用户已存在"){
              this.$router.push({ name: "playletDownload", query:{isRegister:false}});
            }
          },
        });
      } else {
        Toast("请完善输入信息～");
      }
    },

    sendSMS() {
      if (this.isCoding) {
        return;
      }

      if (!this.checkLink()) {
        return;
      }
      if (this.phone && this.phone.length === 11) {
        this.$request.GET({
          url: "verification",
          params: { phone: this.phone, appId: this.appid },
          success: (res) => {
            Toast("验证码发送成功");
            this.isCoding = true;
            this.codingTime = 60;
            this.startCode();
          },
        });
      } else {
        Toast("请输入正确的手机号～");
      }
    },
    startCode() {
      setTimeout(() => {
        this.codingTime--;
        if (this.codingTime > 0) {
           this.btnText = this.codingTime+"s后重发"
          this.startCode();
        } else {
          this.btnText = "发送验证码";
          this.isCoding = false;
        }
      }, 1000);
    },
    checkLink() {
      // if (!this.inviteCode) {
      //   Toast("链接失效～");
      //   return false;
      // }
      return true;
    },
    appSource() {
      const u = navigator.userAgent,
        app = navigator.appVersion;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        this.ios = true;
      } else {
        this.ios = false;
      }
    },
  },
};
</script>

<style scoped>
.container {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url("../../assets/downnew/down_new_bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.column {
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
  flex-direction: row;
}
.center {
  justify-content: center;
}

.codeBtn{
  height: 50px;
  width: 100px;
  color: white;
  font-weight: 500;
  font-size: 16px;
  line-height: 50px;
}
.hi {
  margin-top: 100px;
  width: 80px;
  height: 40px;
}
.welcome {
  height: 20px;
  align-self: flex-end;
}


.btn {
  width: 340px;
  height: 45px;
  background-color: white;
  border-radius: 10px;
  color:black;
  font-size: 21px;
  text-align: center;
  line-height: 45px;
  font-weight: 500;
}

.loginTitle{
  margin-top: 70px;
  object-fit: contain;
  width: 120px;
}

>>>.van-cell{
  border-radius: 6px;
  background-color: rgba(244, 244, 244, 0.3);;
  width: 340px;
  height: 50px;
  font-size: 16px;
  color: white;
  line-height: 50px;
  padding: 0 16px;
}
>>>.van-field__control {
    display: block;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    color: white;
    line-height: inherit;
    text-align: left;
    background-color: transparent;
    border: none;
    resize: none;
}
</style>